<div class="ppl-mt20 p-2">
  @if(staffView) {
  <div class="custom-row pr-3">
    <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
      (click)="onCancel()"></ppl-button>
  </div>
  }
  <div class="warning-message mb-4 alert alert-warning pt-3 pb-3">
  <ul class="mb-0">
    @for (message of alertMessage; track $index) {
      @if(message.authAlert){
        <li class="fs-6 mb-1">{{message.authAlert}}</li>
      }
    }
    <li class="fs-6 mb-1"><strong>Warning:</strong> Manually entering time or editing a clock in / clock out time is not EVV compliant. Please remember to use the Time4Care app to clock in / clock out in real-time.</li>
    @if(timesheetNotAllowedMessage && isPA){
      <li class="fs-6 mt-1">You cannot submit a timesheet this far past the service date. If you need assistance with this issue, please contact PPL customer service at 1-833-247-5346.</li>
    }
  </ul>
</div>

  <form nz-form nz-row [formGroup]="addTimesheetForm" class="ppl-p0 mt-2">
    @if(entryPage === 'timesheets') {
    <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="providerPplId" class="ppl-form-label">Provider PPL ID<span [attr.aria-label]="'Required'">*</span>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
          <input nz-input formControlName="providerPplId" id="providerPplId" />
        </nz-form-control>
        <div class="mr-2 mb-4 ml-2">
          <ppl-button label="Get Consumers" (click)="getConsumersAndPayPeriod()" [customClass]="'primary-button'"
            [iconPosition]="'left'"></ppl-button>
        </div>
      </nz-row>
      @if (pplIdError) {
      <span class="pl-1 error-message">Please enter a PPL ID to search.</span>
      }

    </nz-form-item>

    }

    @if(showFormFields) {

    @if(entryType === 'timeEntry' || action === 'edit'){
    <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="consumer" class="ppl-form-label">
          Consumer
          <span [attr.aria-label]="'Required'">*</span>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
          <div class="ppl-select">
            <ppl-dropdown-select formControlName="consumer" id="consumer" placeholder="Select Consumer"
             (selectionChange)="enableTimesheetForm($event)" [options]="consumers" [optionLabel]="'consumerFullName'"
             [optionValue]="'consumerId'">
            </ppl-dropdown-select>
          </div>
          @if(!consumers || consumers.length == 0){
          <span class="pl-1 error-message">You don't have any active consumers.</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="6" [nzXs]="24" class="ppl-form-label">
          Service Period
          <span [attr.aria-label]="'Required'">*</span>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
          <div class="ppl-select">
            <ppl-dropdown-select id="period" formControlName="period" placeholder="Service Period"
            (selectionChange)="enableTimesheetForm($event)"
            [options]="payPeriod" [optionLabel]="'payPeriod'" [optionValue]="'payrollId'">
            </ppl-dropdown-select>
          </div>
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    @if(showEntries){
    @if(isMobileView){
    <div class="mobile-ui card-layout" formArrayName="timesheetEntries">
      <div class="card" *ngFor="let row of timesheetEntries.controls; let i = index" [formGroupName]="i">
        <div class="card-item">
          <label nz-checkbox formControlName="selected" [attr.aria-label]="'Select row ' + (i + 1)"></label>
          <span class="date-day-text">{{ row.get('serviceDate')?.value | dateWithDayOfWeek }}</span>
        </div>
        <div class="card-item">
          @if(entryType === 'timeEntry' || action==='edit'){
          @if(entryType === 'timeEntry') {
          <div [ngClass]="{ 'error-border': isFieldEmpty('service', i) }" class="ppl-select service-select">
            <ppl-dropdown-select formControlName="service" placeholder="Select Service"
             (selectionChange)="checkService($event, i)" [options]="getFilteredServiceCodesForDate(row.get('serviceDate')?.value)"
             [optionLabel]="'serviceModifierDescription'">
            </ppl-dropdown-select>
          </div>
          } @else {
          <div class="ppl-select service-select" [ngClass]="{ 'error-border': isFieldEmpty('service', i) }">
            <ppl-dropdown-select formControlName="service" placeholder="Select Service"
            (selectionChange)="checkService($event, i)" [options]="serviceCodes"
            [optionLabel]="'serviceModifierDescription'">
            </ppl-dropdown-select>
          </div>
          }
          @if(rowStatus[i] && (entryType === 'timeEntry' || action === 'edit')){
          <div style="margin: 4px 0;">
            <div class="ppl-select" [ngClass]="{ 'error-border': isFieldEmpty('additionalConsumerId', i)}">
              <ppl-dropdown-select formControlName="additionalConsumerId" nzPlaceHolder="Select Consumer"
              [options]="additionalConsumers" [optionLabel]="'consumerFullName'">
              </ppl-dropdown-select>
            </div>
          </div>
          }
          }
        </div>
        <div class="card-item">
          <div class="status-container">
            <span class="label">Time In</span>
            <div [ngClass]="{ 'error-border': isFieldEmpty('serviceTimeIn', i) || isBilledUnitsNegative(i) }">
              <ppl-timepicker formControlName="serviceTimeIn" id="serviceTimeIn"
              [placeholder]="'HH:MM AM/PM'" [ariaLabel]="'Time In'"></ppl-timepicker>
            </div>
            <div *ngIf="fieldErrors[i]?.['timeInEqualTimeOut']">
              <p class="error-message">{{timeInTimeOutEqualMessage}}</p>
            </div>
          </div>
          <div class="status-container">
            <span class="label">Time Out</span>
            <div [ngClass]="{ 'error-border': isFieldEmpty('serviceTimeOut', i) || isBilledUnitsNegative(i) }">
              <ppl-timepicker formControlName="serviceTimeOut" id="serviceTimeOut"
              [placeholder]="'HH:MM AM/PM'" [ariaLabel]="'Time Out'"></ppl-timepicker>
            </div>
            <div *ngIf="fieldErrors[i]?.['timeInAfterTimeOut']">
              <p class="error-message">{{timeOutLessThanTimeInMessage}}</p>
            </div>
            <div *ngIf="fieldErrors[i]?.['timeInAfterTimeOutOverNightShift']">
              <p class="error-message">{{timeOutOverNightShiftMessage}}</p>
            </div>
          </div>
        </div>
        <div class="card-item">
          <input class="billed-units" nz-input formControlName="billedUnits" id="billedUnits"
            placeholder="Billed Units" [attr.aria-label]="'Billed Units for row ' + (i + 1)" />
          @if(entryType === 'timeEntry' || action === 'edit') {
          <div class="ppl-select manual-reason-select" [ngClass]="{ 'error-border': isFieldEmpty('manualReasonLkp', i) }">
            <ppl-dropdown-select formControlName="manualReasonLkp"
            placeholder="Select Reason" [options]="reasonList"
            [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
            </ppl-dropdown-select>
          </div>
          }
        </div>
        @if(entryType === 'timeEntry' || action === 'edit') {
        <div class="card-item">
          @if(action === 'edit' && timesheetEntries.get([i, 'businessStatusLkp'])?.value){
          <div class="status-container">
            <span class="label">Business Status</span>
            <p class="status-text">{{ timesheetEntries.get([i, 'businessStatusLkp'])?.value || null }}</p>
          </div>
          }
          @if(action === 'edit' && timesheetEntries.get([i, 'applicationStatusLkp'])?.value){
          <div class="status-container">
            <span class="label">Processing Status</span>
            @if(timesheetEntries.get([i, 'applicationStatusLkp'])?.value == 'Pended' || timesheetEntries.get([i,
            'applicationStatusLkp'])?.value == 'Denied') {
            <p class="status-text hyperlink" (click)="rowClickedTs(timesheetEntries.get([i,
                    'applicationStatusLkp'])?.value || null, timesheetEntries.get([i,
                    'timeSheetDetailId'])?.value || null)">{{ timesheetEntries.get([i,
              'applicationStatusLkp'])?.value || null }}</p>
            } @else {
            <p class="status-text">{{ timesheetEntries.get([i, 'applicationStatusLkp'])?.value || null }}</p>
            }
          </div>
          }
        </div>
        }

        @if(entryType === 'timeEntry' || action === 'edit' && !isReadOnly){
        @if(action === 'edit'){
        <div class="card-item card-buttons">
          @if(timesheetEntries.get([i, 'businessStatusLkp'])?.value !== 'Paid' || timesheetEntries.get([i,
          'businessStatusLkp'])?.value !== 'Good to Pay') {
          <div *ngIf="!row.get('isNewRow')?.value" nz-tooltip [nzTooltipTitle]="'Add'" class="tooltip-container">
            <ppl-button label="" [disabled]="isAddDisabled(row)" (click)="addTimeSlot(i)" icon="fa fa-plus"
              [customClass]="'ghost-button'" [iconPosition]="'left'"></ppl-button>
          </div>
          <div *ngIf="!row.get('isNewRow')?.value" nz-tooltip [nzTooltipTitle]="'Duplicate'" class="tooltip-container">
            <ppl-button label="" [disabled]="isAddDisabled(row)" (click)="duplicateRow(i)" icon="fa fa-clone"
              [customClass]="'ghost-button'" [iconPosition]="'left'"></ppl-button>
          </div>
          <div *ngIf="row.get('isNewRow')?.value" nz-tooltip [nzTooltipTitle]="'Delete'" class="tooltip-container">
            <ppl-button label="" (click)="deleteRow(i)" icon="pi pi-trash" [customClass]="'ghost-button'"
              [iconPosition]="'left'"></ppl-button>
          </div>
          }

          @if(timesheetEntries.get([i, 'businessStatusLkp'])?.value === 'Saved'){
          <div nz-tooltip [nzTooltipTitle]="'Delete'" class="tooltip-container">
            <ppl-button label="" (click)="openConfirmationPopup(i)" icon="pi pi-trash" [customClass]="'ghost-button'"
              [iconPosition]="'left'"></ppl-button>
          </div>
          }
        </div>
        }

        @if(entryType === 'timeEntry' && action !== 'edit') {
        <div class="card-item card-buttons">
          <div *ngIf="!row.get('isNewRow')?.value" nz-tooltip [nzTooltipTitle]="'Add'" class="tooltip-container">
            <ppl-button label="" [disabled]="isAddDisabled(row)" (click)="addTimeSlot(i)" icon="fa fa-plus"
              [customClass]="'ghost-button'" [iconPosition]="'left'"></ppl-button>
          </div>
          <div *ngIf="!row.get('isNewRow')?.value" nz-tooltip [nzTooltipTitle]="'Duplicate'" class="tooltip-container">
            <ppl-button label="" [disabled]="isAddDisabled(row)" (click)="duplicateRow(i)" icon="fa fa-clone"
              [customClass]="'ghost-button'" [iconPosition]="'left'"></ppl-button>
          </div>
          <div *ngIf="row.get('isNewRow')?.value" nz-tooltip [nzTooltipTitle]="'Delete'" class="tooltip-container">
            <ppl-button label="" (click)="deleteRow(i)" icon="pi pi-trash" [customClass]="'ghost-button'"
              [iconPosition]="'left'"></ppl-button>
          </div>
        </div>
        }
        } @else {
        <div class="card-item card-buttons"></div>
        }
      </div>
    </div>
    }
    @else {
    <table class="table">
      <thead>
        <tr>
          <th style="background-color: #a8e4e14d; width: 3%;"></th>
          <th style="background-color: #a8e4e14d; width: 15%;">Date</th>
          <th style="background-color: #a8e4e14d; width: 20%;">Service Description</th>
          <th style="background-color: #a8e4e14d; width: 10%;">Time In</th>
          <th style="background-color: #a8e4e14d; width: 10%;">Time Out</th>
          <th style="background-color: #a8e4e14d; width: 10%;">Units (15 Mins increment)</th>
          @if(entryType === 'timeEntry' || action === 'edit'){
          <th style="background-color: #a8e4e14d; width: 20%;">Manual Reason*</th>
          @if(action === 'edit'){
          <th style="background-color: #a8e4e14d; width: 8%;">Status</th>
          }
          @if(action === 'edit'){
          <th style="background-color: #a8e4e14d; width: 17%;">Processing Status</th>
          }
          @if(entryType === 'timeEntry' || action === 'edit'){
          <th style="background-color: #a8e4e14d; width: 10%;">Actions</th>
          }
          }
        </tr>
      </thead>
      <tbody formArrayName="timesheetEntries">
        <tr *ngFor="let entry of timesheetEntries.controls; let i = index" [formGroupName]="i">
          <td style="padding-left: 15px;">
            <label nz-checkbox formControlName="selected" [attr.aria-label]="'Select row ' + (i + 1)">
            </label>
          </td>
          <td>
            <span tabindex="0" class="serviceDate">{{ entry.get('serviceDate')?.value | dateWithDayOfWeek }}</span>
          </td>
          <!-- <ng-container formArrayName="timeSlots">
              <ng-container *ngFor="let timeSlot of getTimeSlots(i).controls; let j = index" [formGroupName]="j"> -->
          @if(entryType === 'timeEntry' || action==='edit'){
          <td>
            @if(entryType === 'timeEntry') {
            <div class="ppl-select" [ngClass]="{ 'error-border': isFieldEmpty('service', i) }">
              <ppl-dropdown-select formControlName="service" placeholder="Select Service"
              (selectionChange)="checkService($event, i)" [options]="getFilteredServiceCodesForDate(entry)"
              [optionLabel]="'serviceModifierDescription'">
              </ppl-dropdown-select>
            </div>
            } @else {
            <div class="ppl-select" [ngClass]="{ 'error-border': isFieldEmpty('service', i) }">
              <ppl-dropdown-select formControlName="service" placeholder="Select Service"
               (selectionChange)="checkService($event, i)" [options]="serviceCodes"
               [optionLabel]="'serviceModifierDescription'">
              </ppl-dropdown-select>
            </div>
            }
            @if(rowStatus[i] && (entryType === 'timeEntry' || action === 'edit')){
            <div style="margin: 4px 0;">
              <div class="ppl-select" [ngClass]="{ 'error-border': isFieldEmpty('additionalConsumerId', i) }">
                <ppl-dropdown-select formControlName="additionalConsumerId" placeholder="Select Consumer"
                  [options]="additionalConsumers"
                  [optionLabel]="'consumerFullName'">
                </ppl-dropdown-select>
              </div>
            </div>
            }
          </td>
          }
          @else {
          <td>
            <div class="ppl-select" [ngClass]="{ 'error-border': isFieldEmpty('service', i) }">
              <ppl-dropdown-select formControlName="service" placeholder="Select Service"
               (selectionChange)="checkService($event, i)" [options]="getServiceCodesBasedOnEntryDate(entry)"
               [optionLabel]="'description'">
              </ppl-dropdown-select>
            </div>
          </td>
          }
          <td>
          <div [ngClass]="{ 'error-border': isFieldEmpty('serviceTimeIn', i) || isBilledUnitsNegative(i) }">
            <ppl-timepicker [index]="'0'" formControlName="serviceTimeIn" id="serviceTimeIn"
            [placeholder]="'HH:MM AM/PM'" [ariaLabel]="'Time In'" ></ppl-timepicker>
          </div>
            <div *ngIf="fieldErrors[i]?.['timeInEqualTimeOut']">
              <p class="error-message">{{timeInTimeOutEqualMessage}}</p>
            </div>
          </td>
          <td>
            <div [ngClass]="{ 'error-border': isFieldEmpty('serviceTimeOut', i) || isBilledUnitsNegative(i) }">
              <ppl-timepicker [index]="'0'" formControlName="serviceTimeOut" id="serviceTimeOut"
              [placeholder]="'HH:MM AM/PM'" [ariaLabel]="'Time Out'" ></ppl-timepicker>
            </div>
            <div *ngIf="fieldErrors[i]?.['timeInAfterTimeOut']">
              <p class="error-message">{{timeOutLessThanTimeInMessage}}</p>
            </div>
            <div *ngIf="fieldErrors[i]?.['timeInAfterTimeOutOverNightShift']">
              <p class="error-message">{{timeOutOverNightShiftMessage}}</p>
            </div>
          </td>
          <td>
            <input nz-input formControlName="billedUnits" id="billedUnits" [attr.aria-label]="'Units (15 Mins increment) for row ' + (i + 1)" />
          </td>
          @if(entryType === 'timeEntry' || action === 'edit'){
          <td>
            <div [ngClass]="{ 'error-border': isFieldEmpty('manualReasonLkp', i) }" class="ppl-select">
              <ppl-dropdown-select formControlName="manualReasonLkp" placeholder="Select Reason"
              [options]="reasonList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
              </ppl-dropdown-select>
            </div>
          </td>
          @if(action === 'edit'){
          <td>
            <p>{{ timesheetEntries.get([i, 'businessStatusLkp'])?.value || null }}</p>
          </td>
          }
          @if(action === 'edit'){
          <td>
            @if(timesheetEntries.get([i, 'applicationStatusLkp'])?.value == 'Pended' || timesheetEntries.get([i,
            'applicationStatusLkp'])?.value == 'Denied') {
            <p class="hyperlink" (click)="rowClickedTs(timesheetEntries.get([i,
                'applicationStatusLkp'])?.value || null, timesheetEntries.get([i,
                'timeSheetDetailId'])?.value || null)">{{ timesheetEntries.get([i,
              'applicationStatusLkp'])?.value || null }}</p>
            } @else {
            <p>{{ timesheetEntries.get([i, 'applicationStatusLkp'])?.value || null }}</p>
            }
          </td>
          }
          @if(action === 'edit'){
          @if (isReadOnly) {
          <td></td>
          } @else {
          <td>
            <div class="custom-btn-row">
              @if(timesheetEntries.get([i, 'businessStatusLkp'])?.value !== 'Paid' || timesheetEntries.get([i,
              'businessStatusLkp'])?.value !== 'Good to Pay') {
              <div nz-tooltip [nzTooltipTitle]="'Add Row'" class="tooltip-container mr-2">
                <ppl-button label="" ariaLabel="Add Row" *ngIf="!entry.get('isNewRow')?.value" [disabled]="isAddDisabled(entry)"
                  (click)="addTimeSlot(i)" icon="fa fa-plus" [customClass]="'ghost-button'"
                  [iconPosition]="'left'"></ppl-button>
              </div>
              <div nz-tooltip [nzTooltipTitle]="'Duplicate Row'" class="tooltip-container">
                <ppl-button label="" ariaLabel="Duplicate Row" *ngIf="!entry.get('isNewRow')?.value" [disabled]="isAddDisabled(entry)"
                  (click)="duplicateRow(i)" icon="fa fa-clone" [customClass]="'ghost-button'"
                  [iconPosition]="'left'"></ppl-button>
              </div>
              <div nz-tooltip [nzTooltipTitle]="'Delete Row'" class="tooltip-container mr-2">
                <ppl-button label="" ariaLabel="Delete Row" *ngIf="entry.get('isNewRow')?.value" (click)="deleteRow(i)" icon="pi pi-trash"
                  [customClass]="'ghost-button'" [iconPosition]="'left'"></ppl-button>
              </div>
              }

              @if(timesheetEntries.get([i, 'businessStatusLkp'])?.value === 'Saved'){
              <div nz-tooltip [nzTooltipTitle]="'Delete Row'" class="tooltip-container">
                <ppl-button label="" ariaLabel="Delete Row" (click)="openConfirmationPopup(i)" icon="pi pi-trash"
                  [customClass]="'ghost-button'" [iconPosition]="'left'"></ppl-button>
              </div>
              }
            </div>
          </td>
          }
          }

          @if(entryType === 'timeEntry' && action !== 'edit' && !isReadOnly) {
          <td>
            <div class="custom-btn-row">
              <div nz-tooltip [nzTooltipTitle]="'Add Row'" class="tooltip-container mr-2">
                <ppl-button label="" ariaLabel="Add Row" *ngIf="!entry.get('isNewRow')?.value" [disabled]="isAddDisabled(entry)"
                  (click)="addTimeSlot(i)" icon="fa fa-plus" [customClass]="'ghost-button'"
                  [iconPosition]="'left'"></ppl-button>
              </div>
              <div nz-tooltip [nzTooltipTitle]="'Duplicate Row'" class="tooltip-container">
                <ppl-button label="" ariaLabel="Duplicate Row" *ngIf="!entry.get('isNewRow')?.value" [disabled]="isAddDisabled(entry)"
                  (click)="duplicateRow(i)" icon="fa fa-clone" [customClass]="'ghost-button'"
                  [iconPosition]="'left'"></ppl-button>
              </div>
              <div nz-tooltip [nzTooltipTitle]="'Delete Row'" class="tooltip-container mr-2">
                <ppl-button label="" ariaLabel="Delete Row" *ngIf="entry.get('isNewRow')?.value" (click)="deleteRow(i)" icon="pi pi-trash"
                  [customClass]="'ghost-button'" [iconPosition]="'left'"></ppl-button>
              </div>
            </div>
          </td>
          }

          <!-- </ng-container>
            </ng-container> -->

          }
        </tr>
      </tbody>
      <!-- </table>
      }
      @else {
      <table class="table">
        <thead>
          <tr>
            <th style="padding-left:24px; background-color: #a8e4e14d; width: 25%;">Date</th>
            <th style="background-color: #a8e4e14d; width: 25%;">Service Code</th>
            <th style="background-color: #a8e4e14d; width: 25%;">Hours</th>
            <th style="background-color: #a8e4e14d; width: 25%;">Units</th>
          </tr>
        </thead>
        <tbody formArrayName="timeoffEntries">
          <tr *ngFor="let entry of timeoffEntries.controls; let i = index" [formGroupName]="i">
            <td style="padding-left:24px;">
              <span>{{ entry.get('serviceDate')?.value }}</span>
            </td>

            <td>
              <nz-select class="ppl-select" formControlName="service" nzPlaceHolder="Select Service" nzShowSearch
                nzAllowClear>
                <nz-option *ngFor="let opt of timeOffServiceCodes" [nzLabel]="opt.code" [nzValue]="opt"></nz-option>
              </nz-select>
            </td>
            <td>
              <input nz-input formControlName="hrs" id="hrs" />
            </td>
            <td>
              <input nz-input formControlName="billedUnits" id="billedUnits" />
            </td>
          </tr>
        </tbody>
      } -->
    </table>
    }
    <div class="custom-row">
      <label nz-checkbox formControlName="isAgreed" [ngClass]="{'error-class': isConsentRequired && !isAgreed}">
        By signing below, I certify that I have provided the services to the consumer during the times described on this
        timesheet.
      </label>
    </div>
    @if((entryType === 'timeEntry' || action === 'edit') && !isReadOnly){
    <div class="custom-row" style="width: 100%;">
      @if( !isExternal && entryPage !== 'timesheets') {
      <ppl-button (click)="onMoveBack()" style="margin-right: 8px;" label="Move Back"
        icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
      }

      @if(entryPage !== 'timesheets') {
      <ppl-button [disabled]="isSaveDisabled" (click)="evaluateLongShiftHoursAndSave('save')" style="margin-right: 8px;"
        label="Save" icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
      }

      <ppl-button [disabled]="isSaveDisabled" (click)="evaluateLongShiftHoursAndSave('submit')"
        [label]="entryPage === 'timesheets' ? 'Submit' : 'Save & Submit'" icon="fa fa-check-circle"
        [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
    </div>
    }
    @else if(!isReadOnly){
    <!-- *authorize="[pageId, tabId, 'saveTimeOff', 'button']"  -->
    <div class="custom-row" style="width: 100%;">
      <ppl-button (click)="saveTimeOff()" style="margin-right: 8px;" label="Submit" icon="fa fa-check-circle"
        [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
    </div>
    }

    }
    @else {
    @if (customErrors && customErrors.length) {
    <div class="row">
      <div class="col-12 mb-3">
        <p>
          There is an issue preventing this shift from being entered. If you are unable to resolve the error in red,
          contact PPL customer service at 1-833-247-5346 for help.
        </p>
      </div>
      <div class="col-12">
        <div class="alert alert-danger">
          <strong>Error: </strong>
          @for (error of customErrors; track $index) {
          {{ error }}.<br>
          }
        </div>
      </div>
    </div>
    }
    @else if (addTimesheetForm.get('consumer')?.value && addTimesheetForm.get('period')?.value) {
    <div class="alert alert-danger"><strong>Error: </strong>No Authorization for pay period and consumer.
    </div>
    }

    @if (showFormFields && entryType !== 'timeOff' && consumers?.length < 1 ) { <p>You don't have any active consumers.
      </p>
      }
      }
  </form>
</div>

<div class="filter-panel">
  <ng-template #confirmationDialog let-cancel="cancel">
    <p> Are you sure you want to remove this entry ?</p>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #billedUnitsValidationDialog let-cancel="cancel">
    <p>You have entered a shift that is longer than 13 hours and it needs to be verified. If your shift is correct,
      please click “Yes” to submit your shift. If this is not correct, click “Cancel” to modify your time and resubmit
      your
      shift.</p>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #pendedDialog let-cancel="cancel">
    <ppl-timesheet-staff-errorcode [errorcodeData]="errorcodeData" (onSaveComplete)="onSaveAdjustment($event)"
      [disabled]="true"></ppl-timesheet-staff-errorcode>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #deniedDialog let-cancel="cancel">
    <ppl-timesheet-staff-deniedreasons [deniedData]="deniedData" [disabled]="true"></ppl-timesheet-staff-deniedreasons>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #availableUnitsWarningDialog let-cancel="cancel">
    <p>This shift has exceeded the consumer’s weekly authorization by <strong>{{exceedingTimeFormatted}}</strong>. Please adjust your clock-in/clock-out time as needed.</p>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #exceededUnitsConfirmationDialog let-cancel="cancel">
    <p>Logging time beyond the consumer’s weekly authorization violates CDPAP rules. Are you sure you want to submit? </p>
  </ng-template>
</div>